import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["input", "isReadOnly", "isDisabled", "isClearable", "placeholder", "isRequired", "label", "helperText", "validateOnMount", "meta", "options", "isSearchable", "description", "FormItemProps", "isMulti"];
import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from '../form-group';
import AntSelect from "antd/es/select/index.js";
import useFieldApi from "@data-driven-forms/react-form-renderer/use-field-api";

var selectValue = function selectValue(option) {
  return option.sort(function (a, b) {
    return a.label.localeCompare(b.label, 'en', {
      sensitivity: 'base'
    });
  }).map(function (item) {
    return item.value;
  });
};

var Option = AntSelect.Option;

var Select = function Select(props) {
  var _useFieldApi = useFieldApi(props),
      input = _useFieldApi.input,
      isReadOnly = _useFieldApi.isReadOnly,
      isDisabled = _useFieldApi.isDisabled,
      isClearable = _useFieldApi.isClearable,
      placeholder = _useFieldApi.placeholder,
      isRequired = _useFieldApi.isRequired,
      label = _useFieldApi.label,
      helperText = _useFieldApi.helperText,
      validateOnMount = _useFieldApi.validateOnMount,
      meta = _useFieldApi.meta,
      options = _useFieldApi.options,
      isSearchable = _useFieldApi.isSearchable,
      description = _useFieldApi.description,
      FormItemProps = _useFieldApi.FormItemProps,
      isMulti = _useFieldApi.isMulti,
      rest = _objectWithoutProperties(_useFieldApi, _excluded);

  return /*#__PURE__*/React.createElement(FormGroup, {
    label: label,
    meta: meta,
    validateOnMount: validateOnMount,
    helperText: helperText,
    description: description,
    FormItemProps: FormItemProps,
    isRequired: isRequired
  }, /*#__PURE__*/React.createElement(AntSelect, _extends({}, input, {
    value: input.value ? input.value : undefined,
    defaultValue: input.value ? input.value : undefined,
    placeholder: placeholder || 'Please choose',
    mode: isMulti ? 'multiple' : '',
    showSearch: !!isSearchable || isMulti,
    filterOption: function filterOption(input, option) {
      return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    required: isRequired,
    allowClear: isClearable,
    notFoundContent: "No option found",
    disabled: isDisabled || isReadOnly,
    onChange: function onChange(value, option) {
      return input.onChange(isMulti ? selectValue(option) : option ? option.value : undefined);
    },
    input: input
  }, rest), options.filter(function (option) {
    return Object.prototype.hasOwnProperty.call(option, 'value') && option.value !== null;
  }).map(function (_ref) {
    var value = _ref.value,
        label = _ref.label;
    return /*#__PURE__*/React.createElement(Option, {
      key: value,
      value: value,
      label: label
    }, label);
  })));
};

Select.propTypes = {
  isReadOnly: PropTypes.bool,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.node,
  isRequired: PropTypes.bool,
  label: PropTypes.node,
  helperText: PropTypes.node,
  validateOnMount: PropTypes.bool,
  isSearchable: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.node.isRequired
  })).isRequired,
  description: PropTypes.node,
  FormItemProps: PropTypes.object,
  isMulti: PropTypes.bool
};
export default Select;